import { FunctionComponent, useContext } from "react";

import ScrollableContainer from "../../layout/scrollable-container";
import Footer from "../../components/footer";
import Container from "../../layout/container";

import TransitionWrapper from "../../components/transition-wrapper/TransitionWrapper";

import { TransferContext } from "../../context/TransferContext";

import HeadingContainer from "../../layout/heading-container";
import { BodyLargeBold, BodyMediumRegular, HeadlineMedium, Highlight, LabelMedium } from "../../components/font";
import { Button, tokens } from "@manifesthhqinc/ui-library";
import styled from "styled-components";
import phone from "./assets/phone.svg";
import email from "./assets/mail.svg";
import { AppContext } from "../../context/AppContext";
import { STEP_SCHEDULE_PHONE_CALL } from "../../class/transferDetails";
import { NewTransferStatusType, TransferInstruction } from "../../class/transferInstruction";

const AnnuityContactCardDiv = styled.div`
  border: 1px solid ${tokens.color.border.card.default};
  background: ${tokens.color.neutral["0"]};
  padding: ${tokens.spacing.m} ${tokens.spacing.l};
  display: flex;
  flex-direction: column;
  gap: ${tokens.spacing.xs};
  border-radius: ${tokens.radius.m};
  margin-bottom: ${tokens.spacing.xs};

  .divider {
    width: 100%;
    height: 1px;
    background: ${tokens.color.border.card.default};
    margin: ${tokens.spacing.xs} 0;
  }
`;

const ContactRow = styled.div`
  display: flex;
  gap: ${tokens.spacing.xs};
  align-items: center;
`;
const AnnuityContactScreen: FunctionComponent = () => {
  const { appEnv } = useContext(AppContext);
  const { setShouldShowHomeScreen, userDetails, transferInstructions, goToScreen, hasFailedTask } =
    useContext(TransferContext);

  const onClickGotIt = () => {
    if (appEnv === "BRIDGE_DEVELOPMENT") {
      setShouldShowHomeScreen(true);
      return;
    }
    const phoneCallNeeded = transferInstructions.filter(
      (transferInstruction: TransferInstruction) =>
        transferInstruction.transferInstructionStatus === NewTransferStatusType.SCHEDULE_PHONE_CALL,
    );
    if (phoneCallNeeded.length > 0) {
      goToScreen(STEP_SCHEDULE_PHONE_CALL);
    } else {
      setShouldShowHomeScreen(true);
    }
  };
  if (hasFailedTask) {
    return (
      <TransitionWrapper>
        <ScrollableContainer name="open-ira-exit-screen">
          <Container>
            <HeadingContainer paneVariant="vector" withProgressBar={false}>
              <HeadlineMedium $textAlign="center">Your identity could not be verified</HeadlineMedium>
              <BodyMediumRegular $textAlign="center">
                We've got it from here. We'll keep you updated along the way. Questions? Contact us anytime.
              </BodyMediumRegular>
            </HeadingContainer>

            <AnnuityContactCardDiv>
              <BodyLargeBold>Pacific Life Support</BodyLargeBold>
              <BodyMediumRegular $color={tokens.color.text.secondary}>
                For enrollment or annuity questions, contact Pacific Life:
              </BodyMediumRegular>
              <div className="divider" />
              <ContactRow>
                <img src={phone} alt="phone" />
                <LabelMedium $underline>
                  <Highlight>877-378-0386</Highlight>
                </LabelMedium>
              </ContactRow>
              <ContactRow>
                <img src={email} alt="phone" />
                <LabelMedium $underline>
                  <Highlight>retirementincome@pacificlife.com</Highlight>
                </LabelMedium>
              </ContactRow>
            </AnnuityContactCardDiv>
          </Container>
        </ScrollableContainer>
        <Footer>
          <Button onClick={onClickGotIt} name="exit-manifest" size="large">
            Continue
          </Button>
        </Footer>
      </TransitionWrapper>
    );
  }

  return (
    <TransitionWrapper>
      <ScrollableContainer name="open-ira-exit-screen">
        <Container>
          <HeadingContainer paneVariant="vector" withProgressBar={false}>
            <HeadlineMedium $textAlign="center">
              Great work, <Highlight>{userDetails.firstName}</Highlight>!
            </HeadlineMedium>
            <BodyMediumRegular $textAlign="center" $color={tokens.color.text.secondary}>
              We've got it from here. We'll keep you updated along the way. Questions? Contact us anytime.
            </BodyMediumRegular>
          </HeadingContainer>

          <AnnuityContactCardDiv>
            <BodyLargeBold>Pacific Life Support</BodyLargeBold>
            <BodyMediumRegular $color={tokens.color.text.secondary}>
              For enrollment or annuity questions, contact Pacific Life:
            </BodyMediumRegular>
            <div className="divider" />
            <ContactRow>
              <img src={phone} alt="phone" />
              <LabelMedium $underline>
                <Highlight>877-378-0386</Highlight>
              </LabelMedium>
            </ContactRow>
            <ContactRow>
              <img src={email} alt="phone" />
              <LabelMedium $underline>
                <Highlight>retirementincome@pacificlife.com</Highlight>
              </LabelMedium>
            </ContactRow>
          </AnnuityContactCardDiv>
          <AnnuityContactCardDiv>
            <BodyLargeBold>Manifest Support</BodyLargeBold>
            <BodyMediumRegular $color={tokens.color.text.secondary}>
              For funding or transfer questions, contact Manifest:
            </BodyMediumRegular>
            <div className="divider" />
            <ContactRow>
              <img src={email} alt="phone" />
              <LabelMedium $underline>
                <Highlight>transfers@usemanifest.com</Highlight>
              </LabelMedium>
            </ContactRow>
          </AnnuityContactCardDiv>
        </Container>
      </ScrollableContainer>
      <Footer>
        <Button onClick={onClickGotIt} name="exit-manifest" size="large">
          Got it
        </Button>
      </Footer>
    </TransitionWrapper>
  );
};

export default AnnuityContactScreen;
